import './style.scss'
import { useState } from 'react';
import { AppSpan, AppText, CustomContainer, FlexRow, Icon, Input, ScreenContainer } from 'src/style';
import { MovieDetails } from 'src/component'
import MovieImg from 'src/assets/img/movie-img.svg'
import { FiChevronLeft, FiSearch } from 'react-icons/fi';


export const Movies: React.FC<any> = ({back}) => {
    const [view, setView] = useState('')

    return (
        <>
            <ScreenContainer padding='2.5' topPadding='0'>
                <CustomContainer
                    customRadius='28px 28px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                >
                    <FlexRow gap='3' justifyContent='space-between' wrap='wrap'>
                        <FlexRow width='auto' sizeUnit='' rightMargin='3'>
                            <AppSpan 
                                textSize='2.5' hoverColor='#0D968F' rightMargin='2' topMargin='-0.5'
                                onClick={back}
                            >
                                <FiChevronLeft />
                            </AppSpan>
                            <AppSpan textSize='2.2' fontWeight='700'>Movies</AppSpan>
                        </FlexRow>
                        <CustomContainer
                            radius='0.8' borderColor='#D0D5DD' width='33.5'
                            leftPadding='1.5' rightPadding='1.5'
                            shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                        >
                            <FlexRow>
                                <FiSearch style={{fontSize: '2rem', color: '#667085'}} />
                                <Input 
                                    height='4.4' leftPadding='1' 
                                    placeholder='Search' 
                                />
                            </FlexRow>
                        </CustomContainer>
                    </FlexRow>
                    
                    <FlexRow gap='3' topMargin='2' wrap='wrap' className='movies-flex'>
                        {
                            Array.from(Array(15).keys()).map((item) => {
                                return (
                                    <CustomContainer 
                                        width='14.57' key={item} className='movie-item'
                                        onClick={() => setView('movie-details')}
                                    >
                                        <CustomContainer
                                            radius='1.16' height='18.59' bottomMargin='1.5'
                                        >
                                            <Icon src={MovieImg} minWidth='100' noResize style={{objectFit: 'cover'}}  />
                                        </CustomContainer>
                                        <AppText 
                                            color='#4A4E52' fontWeight='500' fontFamily='Montserrat' 
                                            bottomMargin='0.5' cursor='pointer'
                                        >
                                            Jurassic World
                                        </AppText>
                                        <AppSpan color='#4A4E52' fontWeight='300' fontFamily='Montserrat' cursor='pointer'>1h 12m</AppSpan>
                                    </CustomContainer>
                                )
                            })
                        }
                    </FlexRow>
                </CustomContainer>
            </ScreenContainer>
            { view === 'movie-details' &&
                <MovieDetails
                    close={() => setView('')}
                />
            }
        </>
    );
}
